module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADKADAAQAAAABAAAADAAAAAATDPpdAAAAjElEQVQoFWOcPXt29r9//7oZGBg4gRgf+M7ExFTK8v///3pmZmZfIH0Fn2qgnDZQzQqQBlGQ4tTU1Jf4NABdwgBSy4RPETY5kjWwIJsCtNYfaK0NshgjI+MRoHM3wsQoswFqEtw0mKnINMk2kKyBBeip10ArtUHhTABog9SCQqkCGDIrQJGCTwPU4AoA1bg32r3Tgn0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/卡片开合状态-开.png
// module id = 287
// module chunks = 2